<template>
  <div class="addCategoriesComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <div v-else class="row">
        <div class="col-md-7">
                <v-form 
                    ref="form" 
                    lazy-validation 
                    class="mt-5 col-sm-8 col-md-8"
                    >
                    <v-text-field
                        color="secondary"
                        label="Modo"
                        placeholder="Ingrese el nombre de la categoría"
                        required
                        v-model=formData.nombreModo
                        readonly
                        disabled
                    ></v-text-field>

                    <v-select
                        color="secondary"
                        label="*Categoría Beneficio"
                        placeholder="Selecciona un tipo de categoría beneficio"
                        required
                        :items="categoriasBeneficios"
                        item-text="descripcion"
                        item-value="idCategoriaBeneficio"
                        :rules="typeRules"
                        v-model="formData.idCategoriaBeneficio"
                    ></v-select>

                    <v-select
                        color="secondary"
                        label="*Tipo Categoría"
                        placeholder="Selecciona un tipo de categoría"
                        required
                        :items="tipoCategoria"
                        item-text="nombre"
                        item-value="idTipoCategoriaComercial"
                        :rules="typeRules"
                        v-model="formData.idTipoCategoriaComercial"
                    ></v-select>

                    <v-text-field
                        color=secondary
                        label="*Nombre Categoría"
                        placeholder="Ingrese el nombre de la categoría"
                        required
                        :counter="25" 
                        :maxlength="25"
                        :rules="nameRules"
                        v-model="formData.nombre"
                    ></v-text-field>

                    <v-text-field
                        color=secondary
                        label="*Descripción"
                        placeholder="Ingrese una descripción"
                        :counter="40"
                        :maxlength="40"
                        required
                        :rules="descriptionRules"
                        v-model="formData.descripcion"
                    ></v-text-field>

                    <v-text-field
                        color=secondary
                        label="*Responsable"
                        placeholder="Ingrese un responsable"
                        required
                        :counter="30" 
                        :maxlength="30"
                        :rules="responsibleRules"
                        v-model="formData.responsable"
                    ></v-text-field>

                    <v-text-field
                        color="secondary"
                        label="*Teléfono"
                        placeholder="Ingrese un teléfono"
                        required
                        :rules="[...phoneRules, phoneLengthRule]"
                        v-model="formData.telefono"
                        @keydown="handleKeyDown"
                        inputmode="numeric"
                        pattern="[0-9]{0,10}"
                        maxlength="10"
                    ></v-text-field>

                    <v-text-field
                        color=secondary
                        label="*Correo"
                        placeholder="Ingrese un correo"
                        required
                        :rules="mailRules"
                        :counter="50" 
                        :maxlength="50"
                        v-model="formData.correo"
                    ></v-text-field>
                </v-form>
                <div class="img-btn">
                    <div>
                        <changeImage
                        :idIcon="category.idImagenCategoria"
                        />
                    </div>

                    <v-tooltip left>

                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                fab
                                fixed
                                bottom
                                right
                                dark
                                large
                                color="primary"
                                v-bind="attrs"
                                v-on="on"
                                @click="submitForm"
                                >
                                <v-icon dark>mdi-content-save</v-icon>
                            </v-btn>

                        </template>

                        <span>Actualizar Categoría</span>

                    </v-tooltip>  
                </div>

            </div>
    </div>
  </div>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import changeImage from "@/shared/components/icons_selector/change_image_component.vue";
    import  EventBus  from '@/utils/event_bus.js';
    import {
        BOARD_M,
        GET_STATE_LOADING,
        GET_MODO,
        ACTION_GET_MODE,
        ACTION_GET_CATEGORIES_BENEFITS,
        ACTION_GET_CATEGORY_TYPE,
        ACTION_PUT_UPDATE_CATEGORIES,
    } from "@/views/categories_board/store/types/types.js";

    import Swal from "sweetalert2";

    const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    export default {
    components: {
        changeImage
    },
    name: "detailsCategoriesComponent",
    props: {
        category: {
            required: true,
        },
    },
    data() {
        return {
            formData: {
                idCategoriaComercial: this.category.idCategoriaComercial,
                nombreCategoriaBeneficio: this.category.modo,
                idCategoriaBeneficio: this.category.idCategoriaBeneficio,
                idTipoCategoriaComercial: this.category.idTipoCategoriaComercial,
                nombre: this.category.nombre,
                nombreModo: null,
                descripcion: this.category.descripcion,
                responsable: this.category.responsable,
                telefono: this.category.telefono,
                correo: this.category.correo,
                idModo: null,
                idImagenCategoria: this.category.idImagenCategoria,
            },

            nameRules: [
                v => !!v || "El nombre es requerido",
                v => (v && v.length <= 25) || "El nombre no puede tener más de 25 caracteres"
            ],
            
            typeRules: [
                v => !!v || "El tipo de categoría es requerida"
            ],
            descriptionRules: [
                value => !!value || "La descripción es requerida",
                v => (v && v.length <= 40) || "La descripción no puede tener más de 40 caracteres"
            ],
            responsibleRules: [
                v => !!v || "El responsable es requerido",
                v => (v && v.length <= 40) || "El responsable no puede tener más de 40 caracteres"
            ],
            phoneRules: [
                v => !!v || "El teléfono es requerido",
            ],

            phoneLengthRule: v =>
            (v && v.length >= 7 && v.length <= 10) || "El teléfono debe tener entre 7 y 10 dígitos",

            mailRules: [
                v => !!v || "El correo es requerido",
                v => (v && v.length <= 50) || "El correo no puede tener más de 50 caracteres",
                v => correoRegex.test(v) || "El formato del correo es inválido"
            ],
            
            showErrorMessages: false,
            
            categoriaBeneficioList:[],
            categoriasBeneficios:[],
            tipoCategoria: [],
            
        };
    },
    async mounted() {

        // id del modo
        await this.getMode();
        const modos = await this.modes
        const id = modos[1].idModoCategoria;


        this.tipoCategoria = await this.getTipoCategoriaBoard(id);

        // lista categorias beneficios
        this.categoriaBeneficioList = await this.getCategoriaBeneficio(id);
        this.categoriasBeneficios = this.categoriaBeneficioList.payload;

        if (this.categoriaBeneficioList.payload) {
                            
            this.formData.idModo = modos[1].idModoCategoria;
            this.formData.nombreModo = modos[1].nombre;
        
        }

        EventBus.$on('icon-selected', (iconId) => {
            this.formData.idImagenCategoria = iconId;
        });

    },
    
    methods: {

        async getTipoCategoriaBoard(id) {
            const response = await this.getTipoCategoria(id);
            return response;
        },

        handleKeyDown(event) {
            // Permite solo números y la tecla de borrar
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },

        ...mapActions({
            getMode: `${BOARD_M}${ACTION_GET_MODE}`,
            getCategoriaBeneficio: `${BOARD_M}${ACTION_GET_CATEGORIES_BENEFITS}`,
            putActualizarCategoria: `${BOARD_M}${ACTION_PUT_UPDATE_CATEGORIES}`,
            getTipoCategoria: `${BOARD_M}${ACTION_GET_CATEGORY_TYPE}`,
        }),

        async submitForm() {
            
            const validationErrors = this.validateForm();

        
            if (Object.keys(validationErrors).length > 0) {
                const errorMessages = Object.values(validationErrors).join("<br>");
                Swal.fire({
                    icon: 'error',
                    title: 'Errores de validación',
                    html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                    confirmButtonColor: '#6E17A5'
                });
                return;
            }

            const update = await this.putActualizarCategoria(this.formData);
            this.category.idImagenCategoria = update.idImagenCategoria;
            EventBus.$emit('reload-nameCategories', update.nombre);
            
            if (!update) {
                return Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Debes diligenciar los campos",
                });
            }
        },

        validateForm() {

            this.showErrorMessages = true;

            const errors = {};

            if (!this.formData.idCategoriaBeneficio) {
                errors.categoriaBeneficio =
                "Categoría Beneficio";
            }

            if (!this.formData.idTipoCategoriaComercial) {
                errors.idTipoCategoriaComercial =
                "Tipo Categoría";
            }

            if (!this.formData.nombre || !this.formData.nombre.trim()) {
                errors.nombre = "Nombre Categoría";
            }

            if (!this.formData.descripcion) {
                errors.descripcion = "Descripción";
            }

            if (!this.formData.responsable) {
                errors.responsable = "Responsable";
            }

            if (!this.formData.telefono || !/^[0-9]{7,10}$/.test(this.formData.telefono)) {
                errors.telefono = 'Teléfono';
            }

            if (!this.formData.correo || !correoRegex.test(this.formData.correo) || this.formData.correo.length > 50) {
                errors.correo = 'Correo';
            }

            if (!this.formData.idImagenCategoria) {
                errors.idImagenCategoria = 'Icono';
            }

            return errors;
        },
    },
    computed: {

        ...mapGetters({
            modes: `${BOARD_M}${GET_MODO}`,
            loading: `${BOARD_M}${GET_STATE_LOADING}`,
        }),

    },
   
    };
    
</script>

<style lang="css" scoped>

    /* Css input imagen*/

    .col-md-7 {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 450px;

    }

    .row {
        display: flex;
        justify-content: center;
    }

    /*Resposive*/
    @media screen and (max-width: 1024px) {
        .col-md-7 {
            gap: 250px
        }
    }

    @media screen and (max-width: 768px) {
        .col-md-7 {
            display: flex;
            flex-direction: column-reverse;
            gap: 60px;
        }

    }
    @media screen and (max-width: 425px) {
        .col-md-7 {
            
            display: flex;
            flex-direction: column-reverse;
        } 
    }


</style>
